<nav class="app-navbar">
<button #navItem class="nav-item" type="button" *ngFor="let item of items" (click)="select(item.id)" [attr.data-id]="item.id">
<img class="nav-icon" [src]="isSelected(item.id) ? item.selectedIcon : item.unselectedIcon" [alt]="item.label" width="24" height="24">
<div class="nav-label" [class.selected]="isSelected(item.id)">{{ item.label }}</div>
</button>
<div class="nav-underline-fixed" [style.left.px]="underlineLeftPx" [style.width.px]="underlineWidthPx"></div>
</nav>
 